import * as amplitude from '@amplitude/analytics-browser';

export function trackEvent(eventName: string, eventProps = {}) {
  amplitude.track(eventName, eventProps);
}
